import React from 'react'
import PropTypes from 'prop-types'

import { isSwitchInput } from 'utils/types/features'
import { isEmptyOrNil } from 'utils/functional'
import InputPositionEditor from './base/InputPositionEditor'
import {
  InputOperatorEditor,
  InputValueEditor,
  HysteresisEditor,
  EdgeEditor,
  InputCustomDescription,
} from './base'

const shouldShowInputFormElements = (
  isSixteenBitCanOutput,
  isSingleCondition,
  outputConfig
) => {
  if (isSixteenBitCanOutput) {
    return false
  }
  return !outputConfig
}

const SimpleEditor = ({
  uri,
  isLogicSet,
  isSixteenBitCanOutput,
  isSingleCondition,
  disableFalseValue,
  outputConfig,
  subType,
  uriOptionsByPosition,
  fnId,
  inputUri,
  customDescription,
}) => (
  <>
    <InputCustomDescription
      uri={uri}
      inputUri={inputUri}
      customDescription={customDescription}
      subType={subType}
    />
    {!isEmptyOrNil(uriOptionsByPosition) && isSwitchInput(subType) && (
      <div>
        <InputPositionEditor uri={uri} />
      </div>
    )}
    {shouldShowInputFormElements(isSixteenBitCanOutput, outputConfig) && (
      <>
        <div>
          <InputOperatorEditor uri={uri} fnId={fnId} />
        </div>
        <div>
          <InputValueEditor
            uri={uri}
            fnId={fnId}
            disableFalseValue={disableFalseValue}
          />
        </div>
      </>
    )}

    {isLogicSet && (
      <>
        <HysteresisEditor uri={uri} />
        <EdgeEditor uri={uri} />
      </>
    )}
  </>
)

SimpleEditor.defaultProps = {
  showOperators: false,
  disableFalseValue: false,
}

SimpleEditor.propTypes = {
  uri: PropTypes.string,
  isLogicSet: PropTypes.bool,
  isSixteenBitCanOutput: PropTypes.bool,
  showOperators: PropTypes.bool,
  isSingleCondition: PropTypes.bool,
  disableFalseValue: PropTypes.bool,
  outputConfig: PropTypes.string,
  subType: PropTypes.string,
  uriOptionsByPosition: PropTypes.array,
  fnId: PropTypes.string,
  inputUri: PropTypes.string,
  customDescription: PropTypes.string,
}

export default SimpleEditor
